import * as yup from 'yup';

export const examAssignmentSchema = yup.object().shape({
    gradeLevelMasterId: yup.number().required().min(1, 'Select a grade'),
    examTypeMasterId: yup.number().required().min(1, 'Select a type'),
    examId: yup.number().required().min(1, 'Select an assessment'),
    districtId: yup.number().required().min(1, 'District is required'),
    schoolId: yup.number().required().min(1, 'School is required'),
    classes: yup
        .array()
        .of(
            yup.object().shape({
                classId: yup.number().required('Class is required'),
                studentIds: yup.array().required().min(1, 'At least one student must be selected'),
                teacherIds: yup.array().required().min(1, 'At least one teacher must be selected'),
                students: yup.array().of(
                    yup.object().shape({
                        id: yup.number().required(),
                        name: yup.string().required(),
                    })
                ),
                teachers: yup.array().of(
                    yup.object().shape({
                        id: yup.number().required(),
                        name: yup.string().required(),
                    })
                ),
            })
        )
        .min(1, 'At least one class must be added'),
    numberOfAttemptsAllowed: yup
        .number()
        .required()
        .min(1, 'Must be at least 1')
        .max(5, 'Cannot exceed 5'),
    isSpanishAllowed: yup.boolean().required(),
    duration: yup.number().required(),
    fromDTUTC: yup.date().required('Start date is required').typeError('Invalid date'),
    toDTUTC: yup
        .date()
        .required('End date is required')
        .typeError('Invalid date')
        .min(yup.ref('fromDTUTC'), 'End date must be after start date'),
});
